/**
 * ReviewApiError — an API refusal that carries its status (BON-381).
 *
 * Its own module, deliberately, and not part of `reviewApi.ts`: seven test files
 * replace that module wholesale with `vi.mock('./reviewApi', …)`, and a factory
 * mock only provides the exports it lists. An `instanceof` against a class the
 * mock had dropped would not merely fail to match — `x instanceof undefined`
 * throws a TypeError, turning a handled conflict into a crash, and only in tests.
 * Nothing mocks this file, so the check holds everywhere.
 *
 * The status has to survive as DATA rather than as prose in the message: a 409
 * means "your view of this item is stale", and the caller answers that by
 * refetching, not by rendering text. Matching on the message could never work,
 * because the server's own copy always wins over our fallback.
 */
export class ReviewApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = 'ReviewApiError';
  }
}
